import { feature, featureCollection } from '@turf/turf'
import { Layer, Source } from 'react-map-gl/maplibre'
import { useOsmNewNoteFeature } from '@/components/regionen/pageRegionSlug/hooks/mapState/userMapNotes'
import { useNotesComposeActive } from '../useNotesComposeActive'

/** Teal highlight for the OSM object the new note is about (inspector “create from feature”). */
export const NotesNewRelatedGeometry = () => {
  const notesComposeActive = useNotesComposeActive()
  const osmNewNoteFeature = useOsmNewNoteFeature()
  if (!notesComposeActive || !osmNewNoteFeature) return null

  return (
    <>
      <Source
        id="notes_new_related_geometry"
        type="geojson"
        data={featureCollection([feature(osmNewNoteFeature.geometry)])}
      />
      <Layer
        id="notes_new_related_geometry_area"
        source="notes_new_related_geometry"
        type="fill"
        paint={{
          'fill-color': '#14b8a6',
          'fill-outline-color': '#0f766e',
          'fill-opacity': 0.3,
        }}
        filter={['==', '$type', 'Polygon']}
      />
      <Layer
        id="notes_new_related_geometry_point"
        source="notes_new_related_geometry"
        type="circle"
        paint={{
          'circle-radius': 8,
          'circle-color': '#0f766e',
          'circle-opacity': 0.6,
        }}
        filter={['==', '$type', 'Point']}
      />
      <Layer
        id="notes_new_related_geometry_line"
        source="notes_new_related_geometry"
        type="line"
        paint={{
          'line-width': 12,
          'line-color': '#14b8a6',
          'line-opacity': 0.6,
        }}
        filter={['==', '$type', 'LineString']}
      />
    </>
  )
}
